/***************/
/**  IMPORTS  **/
/***************/
import React from "react";
import {
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";

/***********************/
/**  AMPLIFY IMPORTS  **/
/***********************/

/******************/
/**  PDF STYLES  **/
/******************/
const styles = StyleSheet.create({
    leftRow: {
        flexDirection: "row",
        display: "flex",
        fontSize: "8px",
        marginRight: "7px",
        height: "50px",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid #d3f1cb",
        width: "100px",
        backgroundColor: "#f0ffec",
        borderRadius: "3px",
        padding: "2px",
    },
    rightRow: {
        flexDirection: "row",
        display: "flex",
        fontSize: "8px",
        marginLeft: "5px",
        width: "100px",
        height: "50px",
        justifyContent: "center",
        alignItems: "center",
        border: "1px solid #d3f1cb",
        backgroundColor: "#f0ffec",
        borderRadius: "3px",
        padding: "4px",
    }
    });

const Park = ({park, number, fillHeight, flipped}) => {
    const dynamicStyle = {
        height: fillHeight && fillHeight > 19 ? `${fillHeight}px` : "19px",
    };

    let colorStyle = {}
    if(park){
        const tokens = park.split(" ")
        if(tokens.includes("School")) {
            colorStyle = {
                backgroundColor: `#def7ff`,
                border: "1px solid #cbe8f1",
            };
        } else if (tokens.includes("Park")) {
            colorStyle = {
                backgroundColor: "#f0ffec",
                border: "1px solid #d3f1cb",
            };
        } else {
            colorStyle = {
                backgroundColor: "#f4f4f4",
                border: "1px solid #dfdfdf",
            };
        }
    }

    return (
        <>
            {number === "even" ? (
                <View style={{ flexDirection: 'row', display: 'flex'}}>
                    <View style={{flexDirection: 'column', display: 'flex', width: "450px", alignItems: "flex-end"}}>
                        <View style={[styles.leftRow, dynamicStyle, colorStyle]}>
                            <Text>
                                {park}
                            </Text>
                        </View>
                    </View>
                </View>
            ) : (
                <View style={{ flexDirection: 'row', display: 'flex' }}>
                    <View style={{flexDirection: 'column', display: 'flex'}}>
                        <View style={[styles.rightRow, dynamicStyle, colorStyle]}>
                            <Text>
                                {park}
                            </Text>
                        </View>
                    </View>
                </View>
            )}
        </>
        
    )
};

export default Park;